import { Link, NavLink } from 'react-router'
import { GatedNavItem } from '@/components/GatedNavItem'
import { Button } from '@/components/ui/button'
import { useAuth } from '@/provider/useAuth'
import { useSignupClick } from '@/provider/useSignupClick'
import { useTrackerHref } from '@/provider/useTrackerHref'

// Presence of `auth` selects the nav (spec §7): anonymous -> muted gated
// upsell items; authenticated -> real in-app navigation to History/Schedules.
export function Header() {
  const auth = useAuth()
  const href = useTrackerHref()
  const { signupUrl, onSignupClick } = useSignupClick()

  return (
    // A slim branded band: the mono wordmark + a one-line descriptor give the
    // embedded surface a deliberate "you're in a focused tool" identity, while
    // the shared color tokens keep it unified with the host platform. The
    // backdrop-blur + translucent fill let the canvas grid texture (set on
    // `.tracker-surface`) read faintly through the band.
    <header className="sticky top-0 z-20 flex items-center justify-between gap-3 border-b border-border bg-background/80 px-4 py-3 backdrop-blur-sm sm:px-6">
      <Link to={href('/')} className="flex min-w-0 shrink-0 items-center">
        <span className="whitespace-nowrap text-sm tracking-tight">
          aeo<span className="text-primary"> tracker</span>
        </span>
      </Link>
      <nav className="flex items-center gap-1 sm:gap-3">
        {auth ? (
          <div className="flex items-center gap-1 sm:gap-3">
            <NavLink
              to={href('/history')}
              className="text-sm text-muted-foreground hover:text-foreground px-2"
            >
              History
            </NavLink>
            <NavLink
              to={href('/schedules')}
              className="text-sm text-muted-foreground hover:text-foreground px-2"
            >
              Schedules
            </NavLink>
          </div>
        ) : (
          <>
            <div className="hidden items-center gap-3 sm:flex">
              <GatedNavItem
                label="History"
                tooltip="Sign up on VWAM to save your run history"
                origin="history"
              />
              <GatedNavItem
                label="Schedules"
                tooltip="Sign up on VWAM to schedule recurring runs"
                origin="schedule"
              />
            </div>
            <a href={signupUrl} onClick={() => onSignupClick('header_button')}>
              <Button size="sm">
                <span className="sm:hidden">Sign up →</span>
                <span className="hidden sm:inline">Sign up on VWAM →</span>
              </Button>
            </a>
          </>
        )}
      </nav>
    </header>
  )
}
